/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_components.p, {
    children: ["Допустим, нам необходимо добавить метод ", _jsx(_components.code, {
      children: "drinkSoda"
    }), " в класс ", _jsx(_components.code, {
      children: "RegularProgrammer"
    }), ". Мы знаем, что в офисе есть программисты, которые не пьют газировку. Какой из вариантов ниже не будет нарушать ISP?"]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
